export default __webpack_public_path__ + "static/media/pequenos-artistas.42e2ff07.pdf";